import React, { useContext } from "react";

import Context from "../context";
import DivSpinner from "../../../components/divSpinner";
import { theme } from "../../../theme";
import ColumnSort from "./columnSort";
import { convertDateToUKFormat } from "../../../utils";

const Table = () => {
    const context = useContext(Context);

    return(
        <>
            {context.state.is_loading ? (
                <div style={{height : `${window.innerHeight-387}px`}}>
                    <DivSpinner/>
                </div>
            ) : (
                <div className="table-responsive p-0 m-3">
                    <table className="table align-items-center mb-0">
                        <thead>
                            <tr>
                                {[
                                    'Job ID', 
                                    <span>Job<br/>Created<br/>Date</span>, 
                                    'Tradesperson', 
                                    'Customer', 
                                    <span>Job<br/>duration<br/>(min)</span>, 
                                    <span>Rate<br/>per<br/>hour</span>,
                                    <span>Tradesperson<br/>Charge</span>,
                                    <span>Company<br/>commission</span>,
                                    <span>Sub<br/>total</span>,
                                    <span>Company<br/>commission<br/>(Materials)</span>,
                                    <span>Materials<br/>charge<br/>(Tradesperson)</span>,
                                    'VAT',
                                    'Total',
                                    'Paid',
                                ].map((text, index) => (
                                    <th 
                                        key={index}
                                        className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7"
                                    >
                                        <ColumnSort sortKeyName={text} />
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {context.state.payments.length > 0 ? (
                                <>
                                    {context.state.payments.map((payment, index) => (
                                        <tr key={index}>
                                            {[
                                                payment.job_id,
                                                convertDateToUKFormat(payment.job_create_at),
                                                payment.ftm?.ftm_forename+' - '+payment.ftm?.ftm_surname,
                                                payment.customer?.customer_full_name,
                                                payment.ftm_time_diff+' min',
                                                `${theme.currency} ${payment.ftm_hourly_rate}`,
                                                `${theme.currency} ${payment.job_ftm_value}`,
                                                `${theme.currency} ${payment.company_commission}`,
                                                `${theme.currency} ${payment.job_value}`,
                                                `${theme.currency} ${payment.total_extra_payments_company_commission}`,
                                                `${theme.currency} ${payment.total_extra_payments_ftm_payment}`,
                                                `${theme.currency} ${payment.vat}`,
                                                `${theme.currency} ${payment.final_total_value_with_vat}`,
                                                payment?.job_is_pay_ftm === 1 ? (
                                                    <i 
                                                        className="material-icons text-lg position-relative" 
                                                        style={{color: 'green'}}
                                                    >
                                                        check_circle
                                                    </i>
                                                ) : (
                                                    <i 
                                                        className="material-icons text-lg position-relative" 
                                                        style={{color: 'red'}}
                                                    >
                                                        cancel
                                                    </i>
                                                ),
                                            ].map((text, index) => (
                                                <td className="align-middle" key={index}>
                                                    <span className="text-secondary text-sm font-weight-bold">
                                                        {text}
                                                    </span>
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </>
                            ) : (
                                <tr>
                                    <td colSpan="8">Sorry, no data found!</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    );
}

export default Table;